<template>
  <div>
    <div class="p-4 shadow" style="border-radius: 6px;">
      <h2>Welcome {{ user.first_name }}</h2>
      <hr />
      <!-- <p>{{ user.preferences2 }}</p> -->
      <!-- {{ user.stripe_customer_id }} -->
      <!-- <button class="mylisting-button dark-button mt-2" @click="clearStripeID()">Clear Stripe ID</button> -->
      <button
        class="mylisting-button dark-button mt-1"
        @click="showApplicationModal()"
      >
        View Application
      </button>
      <button
        class="mylisting-button dark-button mt-1"
        @click="showUpdateApplicationModal()"
      >
        Update Application
      </button>
      <button
        class="mylisting-button dark-button mt-1"
        @click="showChangePasswordModal()"
      >
        Change Password
      </button>
      <p class="mt-3" v-if="user.status == 'Applied'">
        Your application is pending administrator review.
      </p>
      <!-- <p class="mt-3" v-if="user.status == 'Application Approved'">We have reviewed your application and would be glad to help you find a Nanny for your family!</p>
      <p class="" v-if="user.status == 'Application Approved'">The next step in the process is to enter your payment inforamtion so we can start searching.</p> -->
      <!-- <p class="mt-3" v-if="user.status == 'Payment Info Entered'">Please book your interview!</p> -->
    </div>

    <!-- <div
      v-if="
        statuses.indexOf(user.status) >=
          statuses.indexOf('Application Approved')
      "
    > -->
    <div>
      <resources :user="user"></resources>
    </div>

    <!-- <div
      v-if="
        statuses.indexOf(user.status) >=
          statuses.indexOf('Application Approved')
      "
      class="profile-tile"
    >
      <package-selection
        :user="user"
        @userUpdated="userUpdated()"
      ></package-selection>
    </div> -->

    <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Application Approved')">
      <documents :user="user"></documents>
    </div>

    <div
      v-if="!user.stripe_customer_id && user.selector1 != 'Sitter'"
      class="p-4 shadow"
      style="border-radius: 6px; margin-top: 40px;"
    >
      <!-- <div v-if="(statuses.indexOf(user.status) < statuses.indexOf('Payment Info Entered')) && !user.stripe_customer_id" class="p-4 shadow" style="border-radius: 6px; margin-top: 40px;"> -->
      <div class="">
        <h4 class="" style="font-weight: 500; margin-bottom: 0;">
          Please Enter Your Payment Information
        </h4>
        <p class="mt-2 mb-4">
          <!-- In order to get started with your search there is a non-refundable
          deposit of $250.  -->
          <!-- The deposit will be deducted from the placement fee. -->
          <span v-if="user.selector1 == 'Sitter'">Your information is securely stored and you will only be charged for services you book.</span>
          <span v-if="user.selector1 == 'Nanny' || user.selector1 == 'Newborn Care Specialist'">There is a non-refundable fee of $250 due with submission, of which $200 will be applied to your final invoice.</span>
          <span v-if="user.selector1 == 'Private Educator'">There is a non-refundable fee of $500 due with submission, of which $400 will be applied to your final invoice.</span>
        </p>
        <payments @subscribed="subscribed()" :email="user.email" :user="user"></payments>
        <div class="mt-2" style="margin-bottom: 40px;">
          <a href="https://www.stripe.com" target="_blank"
            ><img
              src="../../../assets/img/stripe/powered_by_stripe_outline@2x.png"
              alt="Powered by Stripe"
              width="150px"
              style="float: right;"
          /></a>
        </div>
        <!-- <hr> -->
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('payment-modal')">Close</button> -->
      </div>
    </div>

    <!-- ---- Book Interview Tile ---- -->
    <!-- <div v-if="user.status == 'Application Approved'" class="p-4 shadow" style="border-radius: 6px; margin-top: 40px;">
      <h4 class="" style="font-weight: 500; margin-bottom: 0;">Book Interview</h4>
      <p v-if="!user.stripe_customer_id" class="mt-2">Please enter your payment info before selecting an interview time. (:</p>
    </div> -->
    <!-- <div
      v-if="user.status == 'Payment Info Entered'"
      class="p-4 shadow"
      style="border-radius: 6px; margin-top: 40px;"
    >
      <h4 class="" style="font-weight: 500; margin-bottom: 0;">
        Book Family Consultation
      </h4>
      <hr />
      <p class="mt-2">
        Please book a consultation time so we can review your application
        together and make sure we fully understand your needs!
      </p>

      <div class="mt-4 mb-3">
        <a
          href=""
          class="mylisting-button dark-button"
          onclick="Calendly.initPopupWidget({url: 'https://calendly.com/pinknannies/30min'});return false;"
          >Schedule Family Consultation</a
        >
      </div>
    </div> -->

    <!-- <div v-if="user.selector1 == 'Permanent'">
      <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Interview Complete')" class="profile-tile">
        <package-selection :user="user" @userUpdated="userUpdated()"></package-selection>
      </div>
    </div> -->

    <div
      v-if="
        statuses.indexOf(user.status) >=
          statuses.indexOf('Documents Signed')
      "
      class="profile-tile"
    >
      <my-candidates :user="user"></my-candidates>
    </div>

    <!-- <div v-if="user.selector1 == 'Permanent' || user.selector1 == 'Interim'"> -->
    <!-- <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Interview Complete')" class="profile-tile"> -->
    <!-- <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Payment Info Entered')" class="profile-tile">
        <week-scheduler :user="user"></week-scheduler>
      </div> -->
    <!-- </div> -->

    <div v-if="user.status == 'Active' && user.selector1 == 'Sitter'" class="profile-tile">
      <scheduler :user="user"></scheduler>
    </div>

    <div v-if="user.id && !$store.getters.isAgent">
      <feedback :user="user"></feedback>
    </div>

    <modal
      name="application-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5" v-if="user.id">
        <application :user="user"></application>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('application-modal')"
        >
          Close
        </button>
        <!-- <button v-if="experience.id" class="mylisting-button danger-button" @click="deleteExperience(experience)" style="float: right;">Delete</button> -->
      </div>
    </modal>

    <modal
      name="update-aplication-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5" v-if="user.id">
        <family-form-edit @infoSaved="infoSaved()" :user="user" />
      </div>
    </modal>

    <modal
      name="change-password-modal"
      width="85%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5" v-if="user.id">
        <change-password
          @passwordchanged="passwordChanged()"
          :userID="user.id"
        ></change-password>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('change-password-modal')"
        >
          Cancel
        </button>
      </div>
    </modal>
    <modal
      name="password-changed-confirmation-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5">
        <h2>Password has been reset successfully.</h2>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('password-changed-confirmation-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="payment-info-entered-modal"
      width="90%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5">
        <h3>
          Thank you for submitting your payment information, we will be in touch with you shortly!
        </h3>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('payment-info-entered-modal')"
        >
          Close
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";

import Application from "../applications/ApplicationView";
import FamilyFormEdit from "../applications/FamilyFormEdit";
import Payments from "./Payments";
import ChangePassword from "../../general/ChangePassword";
import PackageSelection from "./PackageSelection";
import Documents from "../documents/Documents";
import MyCandidates from "./MyCandidates";
import WeekScheduler from "../jobs/WeekScheduler";
import Scheduler from "../jobs/Scheduler";
import Resources from "./Resources";

// Users
// import Resources from "../../users/Resources";
import Feedback from "../../users/Feedback"

export default {
  props: ["userID"],
  components: {
    Application,
    FamilyFormEdit,
    Payments,
    ChangePassword,
    PackageSelection,
    Documents,
    MyCandidates,
    WeekScheduler,
    Scheduler,
    Resources,
    Feedback,
  },
  data() {
    return {
      user: {},
      statuses: []
    };
  },
  created() {
    this.getUser();
    this.statuses = this.$store.getters.employerStatuses;
  },
  methods: {
    async getUser() {
      const res = await axios.get("/api/people/?id=" + this.userID);
      if (res != null) {
        this.user = res.data[0];
      }
    },
    getUserAndChildren() {
      return new Promise(async (resolve, reject) => {
        let res = await axios.get("/api/people/?id=" + this.userID);
        if (!res) {
          reject();
        }
        this.user = res.data[0];
        res = await axios.get(`/api/children/?user=${this.user.id}`);
        if (!res) {
          reject();
        }
        this.user.children = res.data;
        this.user.children.sort((child1, child2) => child1.id - child2.id);
        resolve();
      });
    },
    async showApplicationModal() {
      await this.getUserAndChildren();
      this.$modal.show("application-modal");
    },
    async showUpdateApplicationModal() {
      await this.getUserAndChildren();
      this.$modal.show("update-aplication-modal");
    },
    infoSaved() {
      this.$modal.hide("update-aplication-modal");
      this.userUpdated();
    },
    subscribed() {
      //
      // Triggered when payment info entered
      //

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        // container: this.fullPage ? null : this.$refs.formContainer,
        container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide();
        // this.$emit('subscribed')
      }, 2000);

      axios
        .patch("/api/people/" + this.user.id.toString() + "/", {
          status: "Payment Info Entered"
        })
        .then(res => {
          console.log(res);

          this.getUser();
          this.$modal.show("payment-info-entered-modal");

          this.$store.dispatch("sendEmails", {
            subject: `Payment Info Entered - ${this.user.first_name} ${this.user.last_name}`,
            message:
              "Hello," +
              "\n\n" +
              `The client ${this.user.first_name} ${this.user.last_name} just entered their payment information.\n\n` +
              "Cheers!",
            from: this.$store.getters.agencyFromEmail,
            emails: [
              this.$store.getters.enginehireLoggingEmail,
              this.$store.getters.agencyAdminEmail
            ],
            reply: this.$store.getters.agencyReplyEmail,
            // userID: this.aakashid,
            userID: 4
          });
        })
        .catch(error => {
          console.log(error);
        });
      // this.getUser()
      // this.$modal.show('payment-info-entered-modal')
    },
    clearStripeID() {
      axios
        .patch("/api/people/" + this.user.id.toString() + "/", {
          stripe_customer_id: ""
          // stripe_customer_id: 'acct_1GDYUZIcCA8L7IlD',
        })
        .then(res => {
          console.log(res);
        })
        .catch(error => {
          console.log(error);
        });
    },
    showChangePasswordModal() {
      this.$modal.show("change-password-modal");
    },
    passwordChanged() {
      this.$modal.hide("change-password-modal");
      this.$modal.show("password-changed-confirmation-modal");
    },
    userUpdated() {
      this.getUser();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/Profile.vue